import { createFileRoute } from "@tanstack/react-router";

import { CollectionsSearchPanel } from "@/features/search/collections/collections-search-panel";

export interface CollectionsSearchParams {
  ids?: string;
}

export const Route = createFileRoute("/_authenticated/search/collections")({
  validateSearch: (
    search: Record<string, unknown>,
  ): CollectionsSearchParams => ({
    ids: typeof search.ids === "string" ? search.ids : undefined,
  }),
  component: CollectionsSearchRoute,
});

function CollectionsSearchRoute() {
  const { ids } = Route.useSearch();
  return <CollectionsSearchPanel initialIds={ids ?? ""} />;
}
